export function Header() {
    
    Alpine.store('creditBadge', {
        credit: null,
        isOpen: false,

        async fetchCredit() {
            try {
                if (window.customerId) {
                    const response = await fetch('https://public.inveterateapi.com/v2.0/storefront/members/' + window.customerId, {
                        method: 'GET',
                        headers: {
                            "X-Inveterate-Api-Key": "e9a55a56957b45019437f01e2cbd1f88"
                        },
                    });
        
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
    
                    const data = await response.json();

                    if (data.data) {
                        this.credit = data.data.credit;
                    }
                }
            } catch (error) {
                console.error('Data error:', error);
            }
        },
    
        init() {
            this.fetchCredit();
        }
    });
}
